export class PaymentUrlInvalid {
  CompanyName: string;
  IsExpired: boolean;
  IsCompleted: boolean;
}
